/* eslint-disable no-redeclare */
import React, { useEffect, useState } from 'react'
import { Field } from 'redux-form'
import { FieldLayoutBox, FieldLayoutGroup } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { RuleDisplayBox } from './RuleDisplayBox'
import _ from 'lodash'
import clsx from 'clsx'

function PasswordBoxPlain (props) {
  const { input = {}, type, groupButton, groupLabel, minpasswordlength = 8, ...rest } = props
  const { value } = input
  let inputType = type || 'password'

  const [valid, setValid] = useState(false)
  const [rules, setRules] = useState({
    numCharacters: {
      Label: '# of characters', Status: false
    },
    useLowerCase: {
      Label: 'Lowercase letter', Status: false
    },
    useUpperCase: {
      Label: 'Capital letter', Status: false
    },
    useNumber: {
      Label: 'Number', Status: false
    },
    useSpecial: {
      Label: 'Special Character (!,%,&,@,#,$,^,*,?,_,~)', Status: false
    }
  })

  function validatePassword (val) {
    const lowerCase = new RegExp('[a-z]')
    const upperCase = new RegExp('[A-Z]')
    const numbers = new RegExp('[0-9]')
    const specialCharacter = new RegExp('[!,%,&,@,#,$,^,*,?,_,~]')
    const passwordLength = new RegExp(`^.{${minpasswordlength},}$`)

    if (val) {
      // Check # of characters
      setRules(_.set(rules, 'numCharacters.Status', !!passwordLength.test(val)))
      setRules(_.set(rules, 'numCharacters.Label', `minimum of ${minpasswordlength} characters`))

      // lowerCase meet requirements
      setRules(_.set(rules, 'useLowerCase.Status', !!lowerCase.test(val)))
      setRules(_.set(rules, 'useLowerCase.Label', 'at least 1 lowercase'))

      // upperCase meet requirements
      setRules(_.set(rules, 'useUpperCase.Status', !!upperCase.test(val)))
      setRules(_.set(rules, 'useUpperCase.Label', 'at least 1 capital letter'))

      // upperCase meet requirements
      setRules(_.set(rules, 'useNumber.Status', !!numbers.test(val)))
      setRules(_.set(rules, 'useNumber.Label', 'at least 1 number'))

      // upperCase meet requirements
      setRules(_.set(rules, 'useSpecial.Status', !!specialCharacter.test(val)))
      setRules(_.set(rules, 'useSpecial.Label', 'at least 1 special character (!,%,&,@,#,$,^,*,?,_,~)'))
    }

    setValid(rules.numCharacters.Status &&
      rules.useLowerCase.Status &&
      rules.useUpperCase.Status &&
      rules.useNumber.Status &&
      rules.useSpecial.Status
    )
  }

  useEffect(() => {
    validatePassword(value)
  }, [value])

  useEffect(() => {
    props.isValid(valid)
  }, [valid])

  return (
    <FieldLayoutBox {...rest} input={input}>
      {({ showError, value, onChange, name, placeHolder, loading, readonly, testId, maxLength, onBlur }) => {
        if (readonly) {
          return <FieldLayoutGroup >
            <input data-tid={testId} className={clsx(showError && 'is-invalid-input')}
              type={inputType} readOnly name={`view${name}`} id={`view${name}`} value={value} />
          </FieldLayoutGroup>
        } else {
          return <div>
            <input data-tid={testId} type={inputType} className={clsx(showError && 'is-invalid-input')}
              name={`text${name}`} id={`text${name}`} placeholder={placeHolder} onChange={onChange} value={value} maxLength={maxLength}/>

            <RuleDisplayBox rules={rules} testValue={value} show={value?.length > 0 && !valid}
              infoMessage={`Password validation requires the following...`}/>
          </div>
        }
      }}
    </FieldLayoutBox>
  )
}

export const PasswordBox = ({ parse, format, fieldType, name, namePrefix, minpasswordlength, isValid, ...rest }) => { return <Field name={namePrefix ? `${namePrefix}.${name}` : name} parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} minpasswordlength={minpasswordlength} isValid={isValid} {...rest} component={PasswordBoxPlain} /> } // eslint-disable-line
export default PasswordBox
